module.exports = __webpack_public_path__ + "img/btn_上传_绿色@2x.964f409f.png";